'use client';

import type { NavigationItem } from '@dealerportal/common';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import MobileMenu from './MobileMenu';
import NavDesktopMenuItems from './NavDesktopMenuItems';
import { NavMobileMenuItemLink } from './NavMobileMenuItemLink';
import './AccordionMenuStyles.css';

type Props = {
  isMobileDevice: boolean;
  menuItems: NavigationItem[];
  className?: string;
};

export function AccordionMenu(props: Props) {
  const menuNameIncludeLowercase = (
    menu: NavigationItem,
    lowercaseMenuName: string
  ): boolean => menu.name?.toLowerCase().includes(lowercaseMenuName) ?? false;

  const keywords = ['products', 'flooring', 'shop'];

  const [filteredMenu, setFilteredMenu] = useState<NavigationItem | null>(
    props.menuItems.find((menu) =>
      keywords.some((keyword) => menuNameIncludeLowercase(menu, keyword))
    ) || null
  );

  useEffect(() => {
    if (!filteredMenu || !filteredMenu.children?.length) {
      setFilteredMenu(null);
    }
  }, [filteredMenu]);

  return (
    <nav id="accordion-menu" className={props.className}>
      {props.isMobileDevice ? (
        <MobileMenu
          filteredMenu={filteredMenu}
          menuItems={props.menuItems}
          menuNameIncludeLowercase={menuNameIncludeLowercase}
          setFilteredMenu={setFilteredMenu}
          ArrowIcon={ArrowIcon}
        />
      ) : (
        <ul className={props.className}>
          {props.menuItems.map((menu, index) => {
            if (!menu.hideInMenu) {
              return (
                <NavDesktopMenuItems
                  key={menu._id}
                  items={menu}
                  depthLevel={0}
                  className={props.className}
                />
              );
            }
            return null;
          })}
        </ul>
      )}
    </nav>
  );
}

export function ArrowIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 320 512" {...props}>
      <path
        fill="currentColor"
        d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
      />
    </svg>
  );
}

export default AccordionMenu;
